import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  href?: string;
  target?: string;
  rel?: string;
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  href,
  target,
  rel,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#C17B5C] text-white hover:bg-[#A66548] focus:ring-[#C17B5C] shadow-md hover:shadow-lg',
    secondary: 'bg-[#D4A5A5] text-white hover:bg-[#C08E8E] focus:ring-[#D4A5A5]',
    outline: 'border-2 border-[#3D2B1F] text-[#3D2B1F] hover:bg-[#3D2B1F] hover:text-white focus:ring-[#3D2B1F]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const combinedClass = cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className);
  if (href) {
    return <motion.a href={href} target={target} rel={rel} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${combinedClass} !bg-[#01E323] !text-black hover:!bg-[#00c91e]`} data-id="element-210">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClass} {...props} data-id="element-211">
      {children}
    </motion.button>;
}